export default "__VITE_ASSET__DPnD0$TC__"